import moment from "moment";

import { ScheduleStopValue } from "@RequestFormV2/defaults/scheduleDefaults";
import { StopTimeType } from "types/MultiStop";

export type PickupDateTime = {
  date: string;
  time: string;
};

const DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

function normalizeTime(time: string | null | undefined): string {
  return time || "00:00:00";
}

export function getPickupDateTime(stops: ScheduleStopValue[] | undefined): PickupDateTime | null {
  const pickup = stops?.[0];
  if (!pickup) return null;

  const { stop_time_type: timeType } = pickup;

  if (timeType === StopTimeType.ASAP_DELIVERY || timeType === StopTimeType.BEFORE) {
    return null;
  }

  const date = pickup.stop_after_date;
  if (!date) return null;

  return {
    date,
    time: normalizeTime(pickup.stop_after_time),
  };
}

export function isDeadlineAfterPickup(
  deadlineDate: string | null | undefined,
  deadlineTime: string | null | undefined,
  pickupDate: string,
  pickupTime: string,
): boolean {
  if (!deadlineDate) return false;

  const deadline = moment(
    `${deadlineDate} ${normalizeTime(deadlineTime)}`,
    DATETIME_FORMAT,
  );
  const pickup = moment(`${pickupDate} ${normalizeTime(pickupTime)}`, DATETIME_FORMAT);

  if (!deadline.isValid() || !pickup.isValid()) return false;

  return deadline.isAfter(pickup);
}
